<template>
	<vxe-modal v-model="showFlag" title="配置用水量阈值" :destroy-on-close="true"
				 :esc-closable="false" width="30%" height="200px" show-footer>
			<div class="actDiv">
				<label>平均一天用水量阈值 :</label>
				<a-input-number  v-model="overLimit" :min="1" :max="100" style="margin:0 0.625rem"/>
				<label>m³</label>
			</div>
			<div style="color: red;font-size: 0.75rem;padding-left: 0.7rem;">
				注意：每次配置会覆盖之前的值.如需修改,多次配置即可.
			</div>
			<template #footer>
				<div class="drawerFooter">
				    <a-button size="small" icon="close" @click="closeView()" style="margin-right: 0.625rem;">取 消</a-button>
				    <a-button size="small"  icon="check" type="primary" @click="onSubmit" :loading="submiting">提 交</a-button>
				</div>
			</template>
	</vxe-modal>
</template>

<script>
	export default {
		data(){
			return {
				showFlag:false,
				overLimit:null,
				submiting:false,
			}
			
		},
		methods: {
			showView() {
				this.showFlag = true;
				this.queryOverLimit();
			},
			queryOverLimit(){
				let url = this.Api.getLastUrl(this.Api.QUERY_OVER_LIMIT_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.overLimit = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submiting = false;
					console.log(error);
				});
			},
			closeView(){
				this.showFlag = false;
			},
			onSubmit(){
				if(this.overLimit == null || this.overLimit.length == 0 ){
					this.$message.error('请输入用水量阈值!');
					return;
				}
				this.submiting = true;
				let url = this.Api.getLastUrl(this.Api.CONFIG_OVER_LIMIT_URL);
				let param = {
					overLimit:this.overLimit
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.submiting = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('配置成功');
						this.closeView();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submiting = false;
					console.log(error);
				});
			},
		},
	}
</script>

<style>
</style>
